var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconGlobal = function SvgElIconGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 0C3.564 0 0 3.564 0 8s3.564 8 8 8 8-3.564 8-8-3.564-8-8-8Zm6.473 7.273h-2.91a11.06 11.06 0 0 0-1.963-5.6 6.52 6.52 0 0 1 4.873 5.6ZM5.89 8.727h4.29c-.217 1.964-.945 3.855-2.108 5.382-1.31-1.527-2.037-3.418-2.182-5.382Zm0-1.454C6.109 5.309 6.836 3.418 8 1.89c1.236 1.6 1.964 3.49 2.11 5.382H5.89Zm.436-5.6a11.695 11.695 0 0 0-1.89 5.6h-2.91c.291-2.691 2.255-4.946 4.8-5.6Zm-4.8 7.054h2.91a11.06 11.06 0 0 0 1.963 5.6 6.52 6.52 0 0 1-4.873-5.6Zm8.146 5.6c1.09-1.672 1.745-3.563 1.963-5.6h2.91c-.364 2.691-2.328 4.946-4.873 5.6Z"
  })));
};
export default SvgElIconGlobal;